import { Moment } from 'moment';

export function interpolateMonth(inputString: string, moment: Moment) {
    return inputString.replace(/\{month\}/g, moment.format("MMMM"));
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/helpers/string-helpers.ts